// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FacultyHonor_faculty-detail-honors__5jv2R .FacultyHonor_faculty-detail-honors-landscape__X8ZNa {
  width: 100%;
  font-size: 14px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  margin-top: 15px;
}
.FacultyHonor_faculty-detail-honors__5jv2R .FacultyHonor_faculty-detail-honors-landscape__X8ZNa .FacultyHonor_list-honors-title__CWQaa {
  margin-bottom: 12px !important;
  display: flex;
  align-items: center;
}
.FacultyHonor_faculty-detail-honors__5jv2R .FacultyHonor_faculty-detail-honors-landscape__X8ZNa .FacultyHonor_list-honors-title__CWQaa .FacultyHonor_title__E64j\\+ {
  font-weight: bold;
  font-size: 16px;
  margin-right: 15px !important;
}
.FacultyHonor_faculty-detail-honors__5jv2R .FacultyHonor_faculty-detail-honors-landscape__X8ZNa .FacultyHonor_see-more__GS\\+sG {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.FacultyHonor_faculty-detail-honors__5jv2R .FacultyHonor_faculty-detail-honors-landscape__X8ZNa .FacultyHonor_see-more__GS\\+sG p {
  cursor: pointer;
  color: var(--explore-color);
  font-size: 14px;
}
.FacultyHonor_faculty-detail-honors__5jv2R .FacultyHonor_faculty-detail-honors-mobile__XOPrU {
  display: none;
}
@media only screen and (max-width: 900px) {
  .FacultyHonor_faculty-detail-honors__5jv2R .FacultyHonor_faculty-detail-honors-landscape__X8ZNa {
    display: none !important;
  }
  .FacultyHonor_faculty-detail-honors__5jv2R .FacultyHonor_faculty-detail-honors-mobile__XOPrU {
    display: block;
  }
}

.FacultyHonor_honor__bB\\+bR {
  margin-bottom: 15px;
}
.FacultyHonor_honor__bB\\+bR .FacultyHonor_name__ogpZc {
  display: flex;
  align-items: flex-start;
}
.FacultyHonor_honor__bB\\+bR .FacultyHonor_name__ogpZc .anticon {
  margin-top: 3px;
}
.FacultyHonor_honor__bB\\+bR .FacultyHonor_name__ogpZc .FacultyHonor_title-honor__4sZjc {
  margin-left: 10px;
}
.FacultyHonor_honor__bB\\+bR .FacultyHonor_name__ogpZc .FacultyHonor_title-honor__4sZjc:hover {
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}
.FacultyHonor_honor__bB\\+bR .FacultyHonor_organization__5alHf {
  color: var(--dark-grey);
}
.FacultyHonor_honor__bB\\+bR .ant-skeleton-paragraph li {
  width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyDetail/Components/FacultyHonor/FacultyHonor.module.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,eAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAAJ;AACI;EACE,8BAAA;EACA,aAAA;EACA,mBAAA;AACN;AAAM;EACE,iBAAA;EACA,eAAA;EACA,6BAAA;AAER;AACI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AACN;AAAM;EACE,eAAA;EACA,2BAAA;EACA,eAAA;AAER;AAEE;EACE,aAAA;AAAJ;AAEE;EACE;IACE,wBAAA;EAAJ;EAEE;IACE,cAAA;EAAJ;AACF;;AAGA;EACE,mBAAA;AAAF;AACE;EACE,aAAA;EACA,uBAAA;AACJ;AAAI;EACE,eAAA;AAEN;AAAI;EACE,iBAAA;AAEN;AADM;EACE,WAAA;EACA,eAAA;EACA,0BAAA;AAGR;AACE;EACE,uBAAA;AACJ;AAEI;EACE,sBAAA;AAAN","sourcesContent":[".faculty-detail-honors {\n  .faculty-detail-honors-landscape {\n    width: 100%;\n    font-size: 14px;\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    padding: 20px;\n    margin-top: 15px;\n    .list-honors-title {\n      margin-bottom: 12px !important;\n      display: flex;\n      align-items: center;\n      .title {\n        font-weight: bold;\n        font-size: 16px;\n        margin-right: 15px !important;\n      }\n    }\n    .see-more {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n      p {\n        cursor: pointer;\n        color: var(--explore-color);\n        font-size: 14px;\n      }\n    }\n  }\n  .faculty-detail-honors-mobile {\n    display: none;\n  }\n  @media only screen and (max-width: 900px) {\n    .faculty-detail-honors-landscape {\n      display: none !important;\n    }\n    .faculty-detail-honors-mobile {\n      display: block;\n    }\n  }\n}\n.honor {\n  margin-bottom: 15px;\n  .name {\n    display: flex;\n    align-items: flex-start;\n    :global(.anticon) {\n      margin-top: 3px;\n    }\n    .title-honor {\n      margin-left: 10px;\n      &:hover {\n        color: blue;\n        cursor: pointer;\n        text-decoration: underline;\n      }\n    }\n  }\n  .organization {\n    color: var(--dark-grey);\n  }\n  :global(.ant-skeleton-paragraph) {\n    li {\n      width: 100% !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faculty-detail-honors": `FacultyHonor_faculty-detail-honors__5jv2R`,
	"faculty-detail-honors-landscape": `FacultyHonor_faculty-detail-honors-landscape__X8ZNa`,
	"list-honors-title": `FacultyHonor_list-honors-title__CWQaa`,
	"title": `FacultyHonor_title__E64j+`,
	"see-more": `FacultyHonor_see-more__GS+sG`,
	"faculty-detail-honors-mobile": `FacultyHonor_faculty-detail-honors-mobile__XOPrU`,
	"honor": `FacultyHonor_honor__bB+bR`,
	"name": `FacultyHonor_name__ogpZc`,
	"title-honor": `FacultyHonor_title-honor__4sZjc`,
	"organization": `FacultyHonor_organization__5alHf`
};
export default ___CSS_LOADER_EXPORT___;
